import {BaseDashlet} from "../../lq_js_common/dashboard/base_dashlet";
import {formatMbpsCapacity} from "../../helpers/scaling";
import {clearDiv} from "../../helpers/builders";
import {debugLog} from '../../helpers/debug_log';

export class ShaperSiteHeaderDashlet extends BaseDashlet {
    constructor(slot) {
        super(slot);
        this.rendered = false;
    }

    title() {
        return "Site Information";
    }

    channelRequests() {
        return [ "SiteDetail" ];
    }

    buildContainer() {
        let base = super.buildContainer();
        base.style.overflow = "auto";
        let content = document.createElement("div");
        content.style.width = "100%";
        content.id = "siteInfo_" + this.slot;
        content.classList.add("text-center", "text-muted", "small");
        this.contentId = content.id;
        base.appendChild(content);
        return base;
    }

    setup() {
        super.setup();
        $("#" + this.contentId).html("<i class='fa fa-spinner fa-spin'></i> Loading...");
    }

    onMessage(msg) {
        if (msg.Data.target !== "site_detail") return;

        // Display Render Status
        // TODO: Promote this to a base class
        if (!this.rendered) {
            let myDiv = document.getElementById(this.id);
            myDiv.classList.add("card", "animate__animated", "animate__fadeIn");
        } else {
            let myDiv = document.getElementById(this.id);
            myDiv.classList.add("animate__animated", "animate__pulse");
            setTimeout(() => {
                myDiv.classList.remove("animate__animated", "animate__pulse");
            }, 1000);
        }

        let body = document.getElementById(this.contentId);
        clearDiv(body);
        debugLog("ShaperSiteHeaderDashlet.onMessage", msg.Data.blob);
        let html = "";
        for (const [key, value] of Object.entries(msg.Data.blob[0])) {
            debugLog(value.header);
            html += "<strong><span class='redactable'>" + value.header.name + "</span>";
            if (value.header.site_type !== null) {
                html += " (" + value.header.site_type + ")";
            }
            html += "</strong>&nbsp;&nbsp;";
            html += "<strong>Limits</strong>: " + formatMbpsCapacity(value.header.download_bandwidth_mbps) + " / " + formatMbpsCapacity(value.header.upload_bandwidth_mbps) + "<br>";
        }
        body.innerHTML = html;

        this.rendered = true;
    }
}

function buildLastSeen(key, value) {
    const lastSeen = value.header.last_seen;
    const lastSeenDate = new Date(lastSeen * 1000); // Convert seconds to milliseconds
    const formattedDate = lastSeenDate.toLocaleString(); // Converts to local timezone
    return simpleFlexDiv("<i class='fa fa-clock'></i>&nbsp;&nbsp;Last seen: " + formattedDate, "lastSeen_" + key);
}

function buildCpu(key, value) {
    let div = document.createElement("div");
    div.id = "cpu_" + key;
    div.classList.add("d-inline-flex", "align-items-center", "small", "text-muted", "me-2");
    let usageColor = "text-success";
    if (value.header.average_cpu_use > 50) {
        usageColor = "text-warning";
    } else if (value.header.average_cpu_use > 75) {
        usageColor = "text-danger";
    }
    let peakColor = "text-success";
    if (value.header.peak_cpu_use > 50) {
        peakColor = "text-warning";
    } else if (value.header.peak_cpu_use > 75) {
        peakColor = "text-danger";
    }
    div.innerHTML = "<i class='fa fa-microchip'></i>&nbsp;&nbsp;CPU: <span class='" + usageColor + "'>" + (value.header.average_cpu_use).toFixed(1) + "%</span>";
    + "&nbsp;(Peak: <span class='" + peakColor + "'>" + (value.header.peak_cpu_use).toFixed(1) + "</span>%)";
    return div;
}

function buildMemory(key, value) {
    let div = document.createElement("div");
    div.id = "memory_" + key;
    div.classList.add("d-inline-flex", "align-items-center", "small", "text-muted", "me-2");
    let usageColor = "text-success";
    if (value.header.memory_percentage > 50) {
        usageColor = "text-warning";
    } else if (value.header.memory_percentage > 75) {
        usageColor = "text-danger";
    }
    div.innerHTML = "<i class='fa fa-memory'></i>&nbsp;&nbsp;Memory: <span class='" + usageColor + "'>" + (value.header.memory_percentage * 100).toFixed(1) + "</span>%";
    return div;
}

function buildActiveCircuits(key, value) {
    let activeCircuits = Math.max(...value.body.active_circuits);
    let div = document.createElement("div");
    div.id = "activeCircuits_" + key;
    div.classList.add("d-inline-flex", "align-items-center", "small", "text-muted", "me-2");
    div.innerHTML = "<i class='fa fa-plug'></i>&nbsp;&nbsp;Active Circuits: " + activeCircuits;
    return div;
}

function buildCapacity(key, value) {
    let div = document.createElement("div");
    div.id = "capacity_" + key;
    div.classList.add("d-inline-flex", "align-items-center", "small", "text-muted", "me-2");
    div.innerHTML = "<i class='fa fa-gauge'></i>&nbsp;&nbsp;Capacity: <i class='fa fa-arrow-down'></i>&nbsp;" + formatMbpsCapacity(value.header.max_mbps_down) + "  <i class='fa fa-arrow-up'></i>&nbsp;" + formatMbpsCapacity(value.header.max_mbps_up);
    return div;
}

function simpleFlexDiv(html, id = "") {
    let div = document.createElement("div");
    if (id !== "") {
        div.id = id;
    }
    div.classList.add("d-inline-flex", "align-items-center", "small", "text-muted", "me-2");
    div.innerHTML = html;
    return div;
}
